import { orchestrator } from 'satcheljs';
import {
    activePoliciesPageLoaded,
    onActiveRetentionPoliciesListSucceeded,
    onActivePoliciesRequestSent,
    onActivePoliciesRequestError,
    onActivePoliciesRequestComplete,
} from '../actions/internalActions';
import getActivePolicies from '../services/getActivePolicies';
import extractRetentionPolicyInfo from '../helpers/extractRetentionPolicyInfo';
import { ActiveRetentionPolicyRowType } from '../store/schema/RetentionPolicyRowType';
import RetentionPolicyTagDisplay from 'owa-service/lib/contract/RetentionPolicyTagDisplay';
import { trace } from 'owa-trace';
import getActivePoliciesListState from '../selectors/getActivePoliciesListState';

/**
 * Orchestrator that get the list of active policies and sets the required data in store
 */
export default orchestrator(activePoliciesPageLoaded, async () => {
    // Early return if we didn't make any change in the lists after last fetch
    if (!getActivePoliciesListState().isStale) {
        return;
    }
    onActivePoliciesRequestSent();
    try {
        const response = await getActivePolicies();

        if (!response.RetentionPolicyTagDisplayCollection) {
            throw new Error('Get active retention policies response is not valid');
        }

        const retentionPolicyTags =
            response.RetentionPolicyTagDisplayCollection.RetentionPolicyTags;

        const policiesMap: { [key: string]: ActiveRetentionPolicyRowType } = {};
        const policyRowIds: string[] = [];

        retentionPolicyTags.forEach((tag: RetentionPolicyTagDisplay) => {
            const refinedTag = extractRetentionPolicyInfo(tag) as ActiveRetentionPolicyRowType;
            const refinedTagId = refinedTag.RetentionId;
            policiesMap[refinedTagId] = refinedTag;
            policyRowIds.push(refinedTagId);
        });

        onActiveRetentionPoliciesListSucceeded(policiesMap, policyRowIds);
    } catch (e) {
        trace.error(e);
        onActivePoliciesRequestError();
        return;
    }
    onActivePoliciesRequestComplete();
});
